export const FAQOPTIONS = {
  home: 'home',
  faq: 'faq',
  chat: 'chat',
  contact: 'contact',
};
